const { SECTION_MODEL_KEY_POINTER } = require('models/daos/section/constants/index.cjs')

const SECTIONS_DOMAIN = 'sections'
const SECTIONS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

const SECTIONS_DOMAIN_MAP_KEY = SECTION_MODEL_KEY_POINTER
const SECTIONS_NAME = {
  HOME: 'home',
  ADDRESS: 'address',
  ARTICLES: 'articles',
  COMMENTS: 'comments',
  EMAIL_TEMPLATES: 'emailTemplates',
  MOTIVATION: 'motivation',
  LOGS: 'logs',
  NEW: 'new',
  NOTIFICATIONS: 'notifications',
  ORDERS: 'orders',
  PROFILE: 'profile',
  PAGES: 'pages',
  PROMO_CODES: 'promoCodes',
  REPORTS: 'reports',
  SEARCH: 'search',
  SETTINGS: 'settings',
  STORE: 'store',
  TOKENS: 'tokens',
  TRAINING: 'training',
  USERS: 'users'
}

const SECTIONS_ITEMS_COUNT_PER_PAGE = 9
const SECTIONS_OPTION = {
  NEXT_PAGE: 'isNextPage',
  FEATURED: 'isFeatured',
  QUERY: 'query'
}

module.exports = {
  SECTIONS_DOMAIN,
  SECTIONS_DOMAIN_MAP_KEY,
  SECTIONS_STATE,
  SECTIONS_NAME,
  SECTIONS_ITEMS_COUNT_PER_PAGE,
  SECTIONS_OPTION
}
